import * as React from 'react';
import clsx from 'clsx';
import { Typography } from '@/components/common';
import { DocumentAlertProps } from '@/interfaces';

export const DocumentAlert: React.FC<DocumentAlertProps> = ({
	tone,
	children,
	action,
}) => {
	return (
		<div
			className={clsx(
				'flex w-full items-center gap-[7px] rounded-lg px-2 py-[7px]',
				{
					'bg-[#FD98341A] text-[#FD9834]': tone === 'warning',
					'bg-[#FFF0F4] text-[#D9003A]': tone === 'danger',
					'bg-[#EAF8EF] text-[#217A45]': tone === 'success',
				}
			)}
		>
			<span
				aria-hidden="true"
				className="h-1.5 w-1.5 shrink-0 rounded-full bg-current"
			/>
			<Typography
				type="regular-10"
				className="min-w-0 flex-1 break-words !font-semibold leading-[15px] !text-current"
			>
				{children}
			</Typography>
			{action}
		</div>
	);
};
